// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import CFWConfig from './components/common/config.vue'
import './style/common/style.css'
import axios from 'axios'
import * as filters from './filters/'

Vue.config.productionTip = false
Vue.use(router)
Vue.use(VueResource)
Vue.use(MintUI)
Vue.prototype.axios = axios
Vue.prototype.CFWConfig = CFWConfig
Vue.http.options.emulateJSON = true;
// Vue.http.options.emulateHTTP = true;

Object.keys(filters).forEach(k => Vue.filter(k, filters[k])) // 注册过滤器

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    return moment(value).format(formatString);
});



// WEBPACK FOOTER //
// ./src/main.js